import { useEffect } from "react";

function useDocumentTitle(title) {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = "ChinookDT-Demo | " + title;

    return () => {
      document.title = prevTitle;
    };
  }, [title]);
}

export default useDocumentTitle;
